import { createRoot } from 'react-dom/client';

export default (component, path = '#root') => {
  const root = createRoot(document.querySelector(path));
  root.render(component, document.querySelector(path));
};
